/*
 *   Copyright (c) 2025 Propally.Inc
 *   All rights reserved.
 */
import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const container = document.getElementById("propally-lp2nd-root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
